module.exports = __webpack_public_path__ + "img/chevron-right.14a98471.svg";